var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableRowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 7C16.5803 7 17 7.41973 17 7.9375L17 16.0625C17 16.5803 16.5803 17 16.0625 17L7.9375 17C7.41973 17 7 16.5803 7 16.0625L7 7.9375C7 7.41973 7.41973 7 7.9375 7L16.0625 7ZM16.375 7.9375C16.375 7.76491 16.2351 7.625 16.0625 7.625L7.9375 7.625C7.76491 7.625 7.625 7.76491 7.625 7.9375L7.625 10.125L16.375 10.125L16.375 7.9375ZM7.625 13.25L16.375 13.25L16.375 10.75L7.625 10.75L7.625 13.25ZM7.625 13.875L7.625 16.0625C7.625 16.2351 7.76491 16.375 7.9375 16.375L16.0625 16.375C16.2351 16.375 16.375 16.2351 16.375 16.0625L16.375 13.875L7.625 13.875Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableRowIcon);
export default __webpack_public_path__ + "static/media/tableRowIcon.5d711bd2b34f67130efacd41822454d9.svg";
export { ForwardRef as ReactComponent };